import * as angular from 'angular';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface BatchSummaryService {
  get(plantId: string, tankId: string, productionDate: string): angular.IPromise<apsViewModels.BatchSummaryItem[]>;
  getBinSummaryInfo(plantId: string, tankId: string, productionDate: string): angular.IPromise<apsViewModels.BatchSummaryItem[]>;
  add(command: apsCommands.BatchSummaryItem[], tankId: string): angular.IPromise<apsViewModels.BatchSummaryItem[]>;
  getDetail(id: string): angular.IPromise<apsViewModels.BatchSummaryItem>;
  update(command: apsCommands.BatchSummaryItem, tankId: string): angular.IPromise<apsViewModels.BatchSummaryItem>;
  remove(command: apsCommands.RemoveById): angular.IPromise<apsViewModels.BatchSummaryItem>;
}

class BatchSummarySvc implements BatchSummaryService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  get(plantId: string, tankId: string, productionDate: string): angular.IPromise<apsViewModels.BatchSummaryItem[]> {
    return this.httpService.get<apsViewModels.BatchSummaryItem[]>(Endpoints.BATCH_SUMMARY, { plantId: plantId, tankId: tankId, productionDate: productionDate });
  }

  getDetail(id: string): angular.IPromise<apsViewModels.BatchSummaryItem> {
    let uri = `${Endpoints.BATCH_SUMMARY}/${id}`;
    return this.httpService.get<apsViewModels.BatchSummaryItem>(uri);
  }

  getBinSummaryInfo(plantId: string, tankId: string, productionDate: string): angular.IPromise<apsViewModels.BatchSummaryItem[]> {
    return this.httpService.get<apsViewModels.BatchSummaryItem[]>(Endpoints.BATCH_SUMMARY_INFO, { plantId: plantId, tankId: tankId, productionDate: productionDate });
  }

  add(command: apsCommands.BatchSummaryItem[], tankId: string): angular.IPromise<apsViewModels.BatchSummaryItem[]> {
    let uri = `${Endpoints.BATCH_SUMMARY}/${tankId}`;
    return this.httpService.post(uri, command);
  }

  update(command: apsCommands.BatchSummaryItem, tankId: string): angular.IPromise<apsViewModels.BatchSummaryItem> {
    let uri = `${Endpoints.BATCH_SUMMARY}/${tankId}`;
    return this.httpService.put(uri, command);
  }

  remove(command: apsCommands.RemoveById): angular.IPromise<apsViewModels.BatchSummaryItem> {
    return this.httpService.delete(Endpoints.BATCH_SUMMARY + '/' + command.id);
  }
}

export default angular
  .module('aps.services.batchSummary', [HttpServiceName])
  .service('batchSummaryService', BatchSummarySvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/batches/batchSummary.service.ts